import { Button, Stack, SxProps } from '@mui/material';
import React from 'react';
import { headingFontBold, vars } from '../../../../Theme';

/** Styles for the workflow cta button. */
const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
};

const buttonColor = {
    outlined: vars.mainGreen,
    contained: vars.white,
    text: vars.font,
};
/**
 * Button Component that allows the user to perform an action.
 */
export default ({ variant, text, onClick, disabled, sx }: ICtaButtonProps) => (
    <Button
        variant={variant}
        onClick={onClick}
        sx={{ ...buttonSx, color: buttonColor[variant], ...sx }}
        disabled={disabled}
    >
        <Stack>{text}</Stack>
    </Button>
);

/**
 * Interface that describes the props for an WorkflowCtaButton component.
 */
interface ICtaButtonProps {
    /** Button variant. */
    variant: 'outlined' | 'contained' | 'text';

    /** Button text. */
    text: string;

    /** Click handler for the button. */
    onClick: React.MouseEventHandler<HTMLButtonElement>;

    /** (OPTIONAL) Button disabled state. */
    disabled?: boolean;

    /** (OPTIONAL) Button styles. */
    sx?: SxProps;
}
